export const setSectionTemplateFormDetails = (sectionTemplateData) => {
    let templateData = {
        [sectionTemplateData.target.name]: [sectionTemplateData.target.value]
    }
    return templateData
}

export const keysDropdownConfig = (configList) => {
    const tempConfiglist = copyObject(configList);
    const tempKey = 'Financial Data Value';
    delete tempConfiglist[tempKey];
    return tempConfiglist;
}
function copyObject(src) {
    return Object.assign({}, src);
}